export class Service {
  public doctorServiceId: number = 0;
  public specialityServiceConfigId: any = null;
  public serviceConfigName: string = "";
  public specialityId: number = null;
  public specialityName: string = "";
  public serviceGroupId: number = null;
  public serviceGroupName: string = "";
  public serviceGroupCategoryId: number = null;
  public serviceGroupCategoryName: string = "";
  public serviceTypeId: number = null;
  public serviceTypeName: string = "";
  public servicewarning: string = "";
  public price: number = null;
  public receivedPrice: number = null;
  public priceFrom: number = 0;
  public priceTo: number = 0;
  public commissionDoctor: number = 0;
  public commissionPatient: number = 0;
  public serviceDuration: number = 0;
  public doctorServiceStatusId: number = null;
  public doctorServiceStatusName: string = "";
  public ordersQty: number = 0;
  public doctorServiceName?: any = null

  public file: any;

  constructor(data?) {
    if (!data) return;

    if (data.doctorServiceId)
      this.doctorServiceId = data.doctorServiceId;

    if (data.specialityServiceConfigId)
      this.specialityServiceConfigId = data.specialityServiceConfigId;

    if (data.serviceConfigName)
      this.serviceConfigName = data.serviceConfigName;

    if (data.specialityId)
      this.specialityId = data.specialityId;

    if (data.specialityName)
      this.specialityName = data.specialityName;

    if (data.serviceGroupId)
      this.serviceGroupId = data.serviceGroupId;

    if (data.serviceGroupName)
      this.serviceGroupName = data.serviceGroupName;

    if (data.serviceGroupCategoryId)
      this.serviceGroupCategoryId = data.serviceGroupCategoryId;

    if (data.serviceGroupCategoryName)
      this.serviceGroupCategoryName = data.serviceGroupCategoryName;

    if (data.serviceTypeId)
      this.serviceTypeId = data.serviceTypeId;

    if (data.serviceTypeName)
      this.serviceTypeName = data.serviceTypeName;

    if (data.price)
      this.price = data.price;

    if (data.receivedPrice)
      this.receivedPrice = data.receivedPrice;

    if (data.priceFrom)
      this.priceFrom = data.priceFrom;

    if (data.priceTo)
      this.priceTo = data.priceTo;

    if (data.commissionDoctor)
      this.commissionDoctor = data.commissionDoctor;

    if (data.commissionPatient)
      this.commissionPatient = data.commissionPatient;

    if (data.serviceDuration)
      this.serviceDuration = data.serviceDuration;

    if (data.doctorServiceStatusId)
      this.doctorServiceStatusId = data.doctorServiceStatusId;

    if (data.doctorServiceStatusName)
      this.doctorServiceStatusName = data.doctorServiceStatusName;

    if (data.ordersQty)
      this.ordersQty = data.ordersQty;
  }
}

export class ServiceConfig {
  public specialityServiceConfigId: number = 0;
  public commissionDoctor: number = 0;
  public commissionPatient: number = 0;
  public isActive: boolean = true;
  public priceFrom: number = 0;
  public priceTo: number = 0;
  public popularPrice: any = '-';
  public specialityServiceConfigNames: string = '';

  constructor(data?) {
    if (!data) return;

    if (data.specialityServiceConfigId)
      this.specialityServiceConfigId = data.specialityServiceConfigId;

    if (data.commissionDoctor)
      this.commissionDoctor = data.commissionDoctor;

    if (data.commissionPatient)
      this.commissionPatient = data.commissionPatient;

    if (data.isActive)
      this.isActive = data.isActive;

    if (data.priceFrom)
      this.priceFrom = data.priceFrom;

    if (data.priceTo)
      this.priceTo = data.priceTo;

    if (data.popularPrice)
      this.popularPrice = data.popularPrice;

    if (data.specialityServiceConfigNames)
      this.specialityServiceConfigNames = data.specialityServiceConfigNames;
  }
}
